<script setup>
import _ from 'lodash'
import defaultStory from './story.js'

const route = useRoute()
const router = useRouter()

// Data
const pageId = ref(Number(route.query.p || 0));
const story = ref(defaultStory);
const unitSize = ref(20);
const isFullScreen = ref('false');
const screenContainer = ref(null)

try {
  await useFetch2('/api/timer', {
    success: res => {
      if (res) {
        story.value = res.value.story
      }
    }
  })
} catch(e) {
  story.value = defaultStory
}

const formatPage = function(res) {
  if (!res) return res
  const ret = {
    title: '',
    theme: 'light',
    background: 'presetCanvas2',
    components: [],
    ...res,
  }
  if (!ret.components || !ret.components.length) {
    ret.components = [
      {
        type: 'title',
        title: ret.title,
      },
    ]
  }
  if (!ret.containerStyle) {
    ret.containerStyle = {}
  }
  if (ret.backgroundStyle) {
    _.noop()
  } else if (ret.background === 'imageCover') {
    ret.backgroundStyle = {
      backgroundSize: 'contain',
      backgroundPosition: 'center center',
      backgroundImage: `url(${ret.backgroundSrc})`,
      backgroundColor: '#000',
      backgroundRepeat: 'no-repeat',
    }
  }
  return ret
}

// Computed
const page = computed(() => {
  let res = story.value.pages[pageId.value]
  res = formatPage(res)
  return res
})

const getPageId = () => {
  return pageId.value
}

const prevPage = computed(() => {
  let pageId = getPageId() - 1
  if (pageId < 0) {
    pageId = story.value.pages.length - 1
  }
  let res = story.value.pages[pageId]
  res = formatPage(res)
  return res
})

const nextPage = computed(() => {
  let pageId = getPageId() + 1
  if (pageId >= story.value.pages.length) {
    pageId = 0
  }
  let res = story.value.pages[pageId]
  res = formatPage(res)
  return res
})

// Methods

const handleNextPage = function(delta) {
  pageId.value += delta
  if (pageId.value >= story.value.pages.length) {
    pageId.value = 0
  } else if (pageId.value < 0) {
    pageId.value = story.value.pages.length - 1
  }
  router.replace('?p=' + pageId.value)
}

const adjustBaseSize = function(delta) {
  unitSize.value += delta
}

const getreqfullscreen = function() {
  const root = document.documentElement
  return (
      root.requestFullscreen ||
      root.webkitRequestFullscreen ||
      root.mozRequestFullScreen ||
      root.msRequestFullscreen
  )
}

const enterFullScreen = function() {
  isFullScreen.value = true
  getreqfullscreen().call(screenContainer.value)
}

const exitFullScreen = function() {
  isFullScreen.value = false
  const element = screenConainer.value
  if (document.exitFullScreen) {
    document.exitFullScreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  } else if (element.msExitFullscreen) {
    element.msExitFullscreen()
  }
}
</script>

<template lang="pug">
div(ref="screenContainer")
  div(
    :key="pageId"
    :class="[page.theme]"
    :style="{ fontSize: `${unitSize}px` }"
  ).slide-screen
    div(
      :style="page.backgroundStyle"
    ).slide-background
    TimersStoryRenderer(
      :story="page.components"
      :style="page.containerStyle"
    )
    div(v-if="prevPage" @click="handleNextPage(-1)").corner-button.prev &lt;&lt; {{ prevPage.title }}
    div(v-if="nextPage" @click="handleNextPage(1)").corner-button.next {{ nextPage.title }} &gt;&gt;
    div.corner-settings
      div(@click="enterFullScreen" v-if="!isFullScreen").corner-button 全屏
      div(@click="exitFullScreen" v-else).corner-button 退出全屏
      div(@click="adjustBaseSize(-1)").corner-button -
      div.corner-button A
      div(@click="adjustBaseSize(1)").corner-button +
</template>

<style lang="scss" scoped>
@import '@/assets/scss-ui-flex';

html,
body {
  font-size: 30px;
  margin: 0;
  padding: 0;
  font-family: sans-serif;
}

.slide-screen {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;
  padding: 30px;
  overflow: hidden;
  @include ui-flex-col;

  &.dark {
    color: #fff;
  }

  &.light {
    color: #000;
  }
}

.slide-title {
  margin: 20px 0;
  font-size: 20px;
}

.rel {
  position: relative;
}

.slide-background {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

$buttonMargin: 10px;
.prev,
.next {
  position: absolute;
  bottom: $buttonMargin;
  left: $buttonMargin;
}

.corner-button {
  font-size: 0.6em;
  padding: 10px 20px;
  opacity: 0.5;
  border-radius: 5px;
  transition: all 0.3s;
  cursor: pointer;
  background: rgba(#000, 0.05);

  &:hover {
    opacity: 1;
    background: rgba(#000, 0.2);
  }
}

.next {
  left: auto;
  right: $buttonMargin;
}

.slide-screen.dark {
  color: #fff;
  background: rgba(#fff, 0.05);

  .prev,
  .next {
    &:hover {
      background: rgba(#fff, 0.2);
    }
  }
}

.corner-settings {
  @include ui-flex-row;
  position: absolute;
  top: $buttonMargin;
  right: $buttonMargin;
}

.stage-container {
  @include ui-flex-col;
  position: relative;
}
</style>
